import { Component } from 'react'
import { observer, inject } from 'mobx-react'
import dayjs from 'dayjs'
import _ from 'lodash'

import { numberToDollars } from '../../../utils'
import ProfileCard from '../ProfileCard'
import ProfileField from '../ProfileField'
import { FieldGroup } from '../ProfileStyle'

class AboutFamilyCard extends Component {
  genderValue(gender) {
    if (gender === 'M') {
      return 'Male'
    }
    if (gender === 'F') {
      return 'Female'
    }
    if (gender !== 'M' && gender !== 'F') {
      return ''
    }
  }

  maritalStatusValue() {
    const { person } = this.props.store
    if (person.maritalStatus === false) {
      return 'Single'
    }
    if (person.maritalStatus === true) {
      return 'Married'
    }
  }

  render() {
    const {
      person,
      spouse,
      dependents,
      config: { isSpendown },
      spouseRetirementStatus,
    } = this.props.store

    return (
      <ProfileCard title='About your family' handleEdit={this.props.showAboutFamily}>
        <FieldGroup>
          <ProfileField label='Marital status' value={this.maritalStatusValue()} />
          {person.maritalStatus === true && (
            <ProfileField
              label='Include a spouse in planning'
              value={person.includeSpouse ? 'Yes' : 'No'}
            />
          )}
        </FieldGroup>

        {person.maritalStatus === true && person.includeSpouse === true && (
          <>
            <FieldGroup>
              <ProfileField label="Spouse's first name" value={spouse.firstName} />
              <ProfileField label="Spouse's gender" value={this.genderValue(spouse.gender)} />
              <ProfileField
                label="Spouse's date of birth"
                value={spouse.birthDate ? dayjs(spouse.birthDate).format('MM/DD/YYYY') : ''}
              />
            </FieldGroup>

            <FieldGroup>
              <ProfileField
                label="Spouse's annual compensation before taxes"
                value={`$${numberToDollars(spouse.annualIncome, true)}`}
              />
              <ProfileField
                label="Spouse's other earned income, annually"
                value={`$${numberToDollars(spouse.otherIncome, true)}`}
              />
            </FieldGroup>

            <FieldGroup>
              <ProfileField label="Spouse's retirement age" value={spouse.retirementAge} />
              <ProfileField
                label='Spouse plan to work part-time after retiring?'
                value={_.get(spouseRetirementStatus, 'planningWorkPartTime', null) ? 'Yes' : 'No'}
              />
              {_.get(spouseRetirementStatus, 'planningWorkPartTime', null) === 1 && (
                <>
                  <ProfileField
                    label='Duration: starting age?'
                    value={_.get(spouseRetirementStatus, 'durationStartingAge', null)}
                  />
                  <ProfileField
                    label='Duration: stopping age?'
                    value={_.get(spouseRetirementStatus, 'durationStoppingAge', null)}
                  />
                  <ProfileField
                    label='Spouse annual income from in-retirement job'
                    value={`$${numberToDollars(
                      _.get(spouseRetirementStatus, 'annualIncome', null),
                      true
                    )}`}
                  />
                </>
              )}
            </FieldGroup>
          </>
        )}

        {!isSpendown &&
          dependents.map(({ id, name, birthDate }) => (
            <FieldGroup key={id}>
              <ProfileField label="Dependent's name" value={name} />
              <ProfileField
                label="Dependent's year of birth"
                value={birthDate ? dayjs(birthDate).format('YYYY') : ''}
              />
            </FieldGroup>
          ))}
      </ProfileCard>
    )
  }
}

export default inject('store')(observer(AboutFamilyCard))
